var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-skeleton-loader",
    {
      staticClass: "ma-0 pa-0",
      attrs: { transition: "scale-transition", type: "image", loading: false }
    },
    [
      _c(
        "v-card",
        {
          staticClass: "pull-up backup-availability--card",
          attrs: { color: _vm.cardColor }
        },
        [
          _c(
            "v-card-title",
            {
              staticClass: "pb-0 overline d-flex justify-center",
              style: "color: " + _vm.fontColor
            },
            [_c("h3", { domProps: { innerHTML: _vm._s(_vm.title) } })]
          ),
          _c(
            "v-card-text",
            {
              staticClass: "d-flex justify-center",
              attrs: { collapse: "", show: "" }
            },
            [
              _c("apexchart", {
                staticClass: "backup-availability--chart",
                attrs: {
                  options: _vm.chartOptions,
                  series: _vm.chartSeries,
                  type: _vm.chartType
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }